import ComposerAttachments from './attachments'
import ComposerTextArea from './textarea'
import Resumable from 'resumablejs'
import PropTypes from 'prop-types'
import React from 'react'

class Editor extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    device: PropTypes.object,
    locale: PropTypes.object,
    network: PropTypes.object
  }

  static propTypes = {
    attachments: PropTypes.array,
    link: PropTypes.object,
    placeholder: PropTypes.string,
    quoted: PropTypes.object,
    submitOnEnter: PropTypes.bool,
    text: PropTypes.string,
    textareaRef: PropTypes.object,
    onAddAttachments: PropTypes.func,
    onAddLink: PropTypes.func,
    onRemoveAttachment: PropTypes.func,
    onRemoveLink: PropTypes.func,
    onSubmit: PropTypes.func,
    onUpdateAttachment: PropTypes.func,
    onUpdateText: PropTypes.func
  }

  static defaultProps = {
    attachments: [],
    link: null,
    placeholder: 'Enter text',
    quoted: null,
    submitOnEnter: true
  }

  editorRef = React.createRef()
  textarea = null

  _handleClick = this._handleClick.bind(this)
  _handleFileAdded = this._handleFileAdded.bind(this)
  _handleFileSuccess = this._handleFileSuccess.bind(this)

  render() {
    return (
      <div className="maha-composer-editor" ref={ this.editorRef } onClick={ this._handleClick }>
        <ComposerTextArea { ...this._getComposerTextArea() } />
        <ComposerAttachments { ...this._getComposerAttachments() } />
      </div>
    )
  }

  componentDidMount() {
    const { admin, device } = this.context
    const { token } = admin
    this.resumable = new Resumable({
      target: '/api/admin/assets/upload',
      chunkSize: device.getChunkSize(),
      permanentErrors: [204, 400, 404, 409, 415, 500, 501],
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    this.resumable.on('fileAdded', this._handleFileAdded)
    this.resumable.on('fileSuccess', this._handleFileSuccess)
    this.resumable.assignDrop(this.editorRef.current)
  }

  _getComposerAttachments() {
    const { attachments, onRemoveAttachment } = this.props
    return {
      attachments,
      onRemove: onRemoveAttachment
    }
  }

  _getComposerTextArea() {
    const { attachments, link, placeholder, quoted, submitOnEnter, text, textareaRef, onAddAttachments } = this.props
    const { onAddLink, onRemoveLink, onSubmit, onUpdateAttachment, onUpdateText } = this.props
    const { t } = this.context.locale
    return {
      attachments,
      link,
      quoted,
      placeholder: t(placeholder),
      reference: node => this.textarea = node,
      textareaRef,
      submitOnEnter,
      value: text,
      onAddAttachments,
      onAddLink,
      onChange: onUpdateText,
      onEnter: onSubmit,
      onRemoveLink,
      onUpdateAttachment
    }
  }

  _handleClick() {
    this.textarea.focus()
  }

  _handleFileAdded(file) {
    this.resumable.upload()
    this.props.onAddAttachments({ file })
  }

  _handleFileSuccess(file, message) {
    const response = JSON.parse(message)
    const asset = response.data
    this.resumable.removeFile(file)
    this.props.onUpdateAttachment(file.uniqueIdentifier, asset)
  }

}

export default Editor
